import {SET_NEW_GROUP_LIST} from './../../actions/Header/types';

const initialState = {
  group_list: sessionStorage.getItem('group_list') ? JSON.parse(sessionStorage.getItem('group_list')): [],
  clients: sessionStorage.getItem('clients') ? JSON.parse(sessionStorage.getItem('clients')): [],
  nit: sessionStorage.getItem('nit') ? JSON.parse(sessionStorage.getItem('nit')): [],
  lang: sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : "ES",
  variableBranch: sessionStorage.getItem('variableBranch') ? JSON.parse(sessionStorage.getItem('variableBranch')): [],
};

const HeaderReducer = (state = initialState, action) => {
  switch(action.type){
  case SET_NEW_GROUP_LIST:
    return {
      group_list: action.payload.group_list,
      clients: action.payload.clients,
      nit: action.payload.nit,
      lang: action.payload.lang,
      variableBranch: action.payload.variableBranch
    };
  default:
    return state;
  }
};

export default HeaderReducer;